import { render, staticRenderFns } from "./equityMall.vue?vue&type=template&id=581efc94&scoped=true"
import script from "./equityMall.vue?vue&type=script&lang=js"
export * from "./equityMall.vue?vue&type=script&lang=js"
import style0 from "./equityMall.vue?vue&type=style&index=0&id=581efc94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581efc94",
  null
  
)

export default component.exports